const countries = [
  'Австрия',
  'Германия',
  'Россия', 'Франция', 'Италия', 'Испания', 'Польша', 'Украина', 'Казахстан',
  'США', 'Канада', 'Бразилия', 'Аргентина', 'Китай', 'Япония', 'Южная Корея', 'Индия',
  'Великобритания', 'Австралия', 'Турция', 'Израиль', 'Швеция', 'Норвегия', 'Финляндия',
  'Чехия', 'Словакия', 'Румыния', 'Болгария', 'Греция', 'Португалия', 'Швейцария'
];

export default countries;
